import { ItemName, Locale } from '@ps-smart-cp/ppfw-client';

const names = {
  maintenance: ItemName.of([Locale.ja, '会社情報設定'], [Locale.en, 'Company Information Setting']),
  companyInfoChange: ItemName.of([Locale.ja, '会社情報変更'], [Locale.en, 'Company Information Change']),
  basicCompanyInfo: ItemName.of([Locale.ja, '基本情報'], [Locale.en, 'Basic Information']),
  companyLocationInfo: ItemName.of([Locale.ja, '所在地情報'], [Locale.en, 'Location Information']),
};

const companySetting = {
  names,
};

export { companySetting };
